import React from 'react';
import { Route, Redirect } from 'react-router';
import { OTHER_ROUTES, ROUTES } from 'utils/routes';
import Overview from 'containers/Overview';
import Campaigns from 'containers/Campaigns';
import Voids from 'containers/Voids';
import Accounts from 'containers/Accounts';
import Items from 'containers/Items';
import Favorites from 'containers/Favorites';
import Details from 'containers/Details';
import CampaignDetails from 'containers/Campaigns/DetailsPage';
import GroupDetails from 'containers/Groups/Details';
import Groups from 'containers/Groups';
import Scorecards from 'containers/Scorecards';

const CommonRoutes = () => (
  <>
    <Route exact path="/">
      <Redirect to={ROUTES.OVERVIEW} />
    </Route>
    <Route exact path={ROUTES.OVERVIEW} key={ROUTES.OVERVIEW} component={Overview} />
    <Route exact path={ROUTES.CAMPAIGNS} key={ROUTES.CAMPAIGNS} component={Campaigns} />
    <Route exact path={ROUTES.VOIDS} key={ROUTES.VOIDS} component={Voids} />
    <Route exact path={ROUTES.ACCOUNTS} key={ROUTES.ACCOUNTS} component={Accounts} />
    <Route exact path={ROUTES.ITEMS} key={ROUTES.ITEMS} component={Items} />
    <Route exact path={ROUTES.FAVORITES} key={ROUTES.FAVORITES} component={Favorites} />
    <Route path={OTHER_ROUTES.DETAILS} key={OTHER_ROUTES.DETAILS} component={Details} />
    <Route
      path={OTHER_ROUTES.CAMPAIGN_DETAILS}
      key={OTHER_ROUTES.CAMPAIGN_DETAILS}
      component={CampaignDetails}
    />
    <Route
      path={OTHER_ROUTES.GROUP_DETAILS}
      key={OTHER_ROUTES.GROUP_DETAILS}
      component={GroupDetails}
    />
    <Route exact path={ROUTES.GROUPS} key={ROUTES.GROUPS} component={Groups} />
    <Route exact path={ROUTES.SCORECARDS} key={ROUTES.SCORECARDS} component={Scorecards} />
  </>
);

export default CommonRoutes;
